import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { EnterValueDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import { EnterValueInput } from '../../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { EinheitSelectorComponent } from '../../../components/einheit-selector/einheit-selector.component';
import { Einheit } from '../../../components/einheit-selector/einheit';
import { KieneAutocompleteComponent } from '../../../components/kiene-autocomplete/kiene-autocomplete.component';
import { Supplier } from '../../../warehouse/supplier/supplier';
import { Material, ArtikelStueckliste } from '../../../warehouse/material/material';
import { SaveForAllDialogComponent } from '../../../dialogs/save-for-all-dialog/save-for-all-dialog.component';
import { Mandant } from '../../../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { ConfirmDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogInput } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';

export interface MandantMargeData {
    mandant_id: number;
    marge: number;
}

export interface BehandlungsartikelData {
    artikel_id?: number;
    bezeichnung?: string;
    bezeichnung_befund?: string;
    kuerzel?: string;
    ean?: string;
    artikelnr_lieferant?: string;
    menge?: number;
    einheit_id?: number;
    einzelpreis?: number;
    stueckliste_einkaufspreis?: number;
    verkaufspreis?: number;
    marge?: number;
    laborartikel?: number;
    befund?: number;
    stueckliste?: number;
    lieferant_id_labor?: number;
    lieferant_bezeichnung?: string;
    warengruppe_id?: number;
    warengruppe?: string;
    gesperrt?: number;
    idexx?: number;
    idexx_messgroesse?: string;
    idexx_pdf_beschreibung?: string;
    idexx_pdf_tabellen_text?: string;
    artikel_nr_intern?: number;
}

@Component({
    selector: 'kiene-add-behandlungsartikel-dialog',
    templateUrl: './add-behandlungsartikel-dialog.component.html',
    styleUrls: ['./add-behandlungsartikel-dialog.component.scss'],
})
export class AddBehandlungsartikelDialogComponent implements OnInit {
    @ViewChild('einheitSelector') einheitSelector: EinheitSelectorComponent;
    @ViewChild('lieferantAutocomplete') lieferantAutocomplete: KieneAutocompleteComponent;

    edit = false;
    artikel: BehandlungsartikelData = {};

    bezeichnungCtrl = new UntypedFormControl('', [Validators.required]);
    bezeichnungBefundCtrl = new UntypedFormControl('');
    kuerzelCtrl = new UntypedFormControl('');
    eanCtrl = new UntypedFormControl('');
    artikelnrLieferantCtrl = new UntypedFormControl('');
    mengeCtrl = new UntypedFormControl(1);
    einzelpreisCtrl = new UntypedFormControl(null);
    stuecklisteEinkaufspreisCtrl = new UntypedFormControl(null); // Einkaufspreis aus Stückliste
    verkaufspreisCtrl = new UntypedFormControl(null);
    margeCtrl = new UntypedFormControl(20); // Standard: 20%
    artikeltypCtrl = new UntypedFormControl('labor'); // 'labor' oder 'diagnostik'
    stuecklisteCtrl = new UntypedFormControl(false);
    gesperrtCtrl = new UntypedFormControl(false);
    idexxCtrl = new UntypedFormControl(false);
    idexxMessgroesseCtrl = new UntypedFormControl('');
    idexxPdfBeschreibungCtrl = new UntypedFormControl('');
    idexxPdfTabellenTextCtrl = new UntypedFormControl('');
    selectedTabIndex = 0; // Aktueller Tab-Index für Grunddaten/Stückliste

    selectedEinheit: Einheit;
    selectedLieferant: Supplier;
    allEinheiten: Einheit[] = []; // Alle Einheiten für die Auswahl

    isSaving = false;
    materialForStueckliste: Material;
    private isCalculatingVerkaufspreis = false;
    private isCalculatingMarge = false;
    private verkaufspreisManuellGesetzt = false; // Flag, ob Verkaufspreis manuell gesetzt wurde
    artikelSameNameOtherMandanten: any[] = []; // Artikel mit derselben Bezeichnung bei anderen Mandanten
    private wurdeFuerMehrereMandantenErstellt = false; // Flag, ob Artikel bereits für mehrere Mandanten erstellt wurde

    constructor(
        public dialogRef: MatDialogRef<AddBehandlungsartikelDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneTableService,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
        private dialog: MatDialog,
    ) {
        if (data && data.artikel) {
            this.artikel = { ...data.artikel };
            this.edit = true;
        }
    }

    ngOnInit() {
        // Einheiten laden, damit wir die Einheit aus der ID setzen können
        this.loadEinheiten(() => {
            // Nach dem Laden der Einheiten initEditMode oder initCreateMode aufrufen
        if (this.edit) {
            this.initEditMode();
        } else {
            this.initCreateMode();
            }
        });

        // Verkaufspreis berechnen, wenn Einkaufspreis oder Marge geändert wird
        // Einkaufspreis oder Marge haben Priorität - Verkaufspreis wird immer neu berechnet
        this.einzelpreisCtrl.valueChanges.subscribe(() => {
            if (!this.isCalculatingMarge) {
                // Einkaufspreis geändert → Verkaufspreis neu berechnen (überschreibt manuell gesetzten Wert)
                this.verkaufspreisManuellGesetzt = false;
                this.calculateVerkaufspreis();
            }
        });
        this.margeCtrl.valueChanges.subscribe(() => {
            if (!this.isCalculatingMarge) {
                // Marge geändert → Verkaufspreis neu berechnen (überschreibt manuell gesetzten Wert)
                this.verkaufspreisManuellGesetzt = false;
                this.calculateVerkaufspreis();
            }
        });
        this.stuecklisteEinkaufspreisCtrl.valueChanges.subscribe(() => {
            if (!this.isCalculatingMarge) {
                // Stücklisten-Einkaufspreis geändert → Verkaufspreis neu berechnen (überschreibt manuell gesetzten Wert)
                this.verkaufspreisManuellGesetzt = false;
                this.calculateVerkaufspreis();
            }
        });
        // Marge berechnen, wenn Verkaufspreis manuell geändert wird (niedrigste Priorität)
        this.verkaufspreisCtrl.valueChanges.subscribe(() => {
            if (!this.isCalculatingVerkaufspreis) {
                const verkaufspreis = this.verkaufspreisCtrl.value;
                if (verkaufspreis && verkaufspreis > 0) {
                    // Markiere, dass Verkaufspreis manuell gesetzt wurde
                    this.verkaufspreisManuellGesetzt = true;
                    this.calculateMarge();
                } else {
                    // Verkaufspreis wurde gelöscht - Flag zurücksetzen und automatisch berechnen
                    this.verkaufspreisManuellGesetzt = false;
                    this.calculateVerkaufspreis();
                }
            }
        });
    }

    loadEinheiten(callback?: () => void) {
        this.api.get(this.apiBaseUrl + 'einheit/read.php').subscribe(response => {
            this.allEinheiten = response.records;
            // Wenn wir im Edit-Modus sind und eine einheit_id haben, setze die Einheit
            if (this.edit && this.artikel.einheit_id !== null && this.artikel.einheit_id !== undefined && this.allEinheiten.length > 0) {
                const einheit = this.allEinheiten.find(e =>
                    KieneUtils.sameId(e.einheit_id, this.artikel.einheit_id),
                );
                if (einheit) {
                    this.selectedEinheit = einheit;
                    // Selector ggf. aktualisieren (EinheitSelector reagiert nicht auf spätere preselected-Änderungen)
                    setTimeout(() => {
                        if (this.einheitSelector) {
                            this.einheitSelector.einheitCtrl.setValue(einheit);
                        }
                    }, 0);
                }
            }
            if (callback) {
                callback();
            }
        });
    }

    initEditMode() {
        this.bezeichnungCtrl.setValue(this.artikel.bezeichnung || '');
        this.bezeichnungBefundCtrl.setValue(this.artikel.bezeichnung_befund != null ? this.artikel.bezeichnung_befund : '');
        this.kuerzelCtrl.setValue(this.artikel.kuerzel || '');
        this.eanCtrl.setValue(this.artikel.ean || '');
        this.artikelnrLieferantCtrl.setValue(this.artikel.artikelnr_lieferant || '');
        this.mengeCtrl.setValue(this.artikel.menge || 1);
        this.einzelpreisCtrl.setValue(this.artikel.einzelpreis);
        this.stuecklisteEinkaufspreisCtrl.setValue(this.artikel.stueckliste_einkaufspreis || 0);
        this.verkaufspreisCtrl.setValue(this.artikel.verkaufspreis);
        this.margeCtrl.setValue(this.artikel.marge);
        this.gesperrtCtrl.setValue(KieneUtils.isApiOne(this.artikel.gesperrt));
        
        // Prüfe, ob es Artikel mit derselben Bezeichnung bei anderen Mandanten gibt
        this.checkSameNameOtherMandanten();

        // Artikeltyp bestimmen basierend auf Warengruppe
        // (laborartikel Feld wird beim Speichern automatisch korrekt gesetzt)
        if (this.artikel.warengruppe === 'Diagnostikartikel') {
            this.artikeltypCtrl.setValue('diagnostik');
        } else if (this.artikel.warengruppe === 'Laborartikel') {
            this.artikeltypCtrl.setValue('labor');
        } else {
            // Fallback für andere Warengruppen: Default zu Labor
            this.artikeltypCtrl.setValue('labor');
        }

        // Wenn Diagnostikartikel: Stückliste/Idexx sicher deaktivieren (auch wenn Alt-Daten existieren)
        // WICHTIG: Bei Diagnostikartikel IMMER auf false setzen, unabhängig von artikel.stueckliste
        if (this.artikeltypCtrl.value === 'diagnostik') {
            this.stuecklisteCtrl.setValue(false, { emitEvent: false });
            this.stuecklisteCtrl.disable({ emitEvent: false });
            this.idexxCtrl.setValue(false, { emitEvent: false });
            this.idexxCtrl.disable({ emitEvent: false });
            this.idexxMessgroesseCtrl.setValue('', { emitEvent: false });
            this.idexxPdfBeschreibungCtrl.setValue('', { emitEvent: false });
            this.idexxPdfTabellenTextCtrl.setValue('', { emitEvent: false });
        } else {
            // Bei Laborartikel: Stückliste und Idexx aus Artikel-Daten setzen
            this.stuecklisteCtrl.setValue(KieneUtils.isApiOne(this.artikel.stueckliste));
            this.idexxCtrl.setValue(KieneUtils.isApiOne(this.artikel.idexx));
            // Idexx-Felder nur bei Laborartikeln setzen
            this.idexxMessgroesseCtrl.setValue(this.artikel.idexx_messgroesse || '');
            this.idexxPdfBeschreibungCtrl.setValue(this.artikel.idexx_pdf_beschreibung || '');
            this.idexxPdfTabellenTextCtrl.setValue(this.artikel.idexx_pdf_tabellen_text || '');
        }

        // Wenn Verkaufspreis und Einkaufspreis vorhanden sind, Marge daraus berechnen
        // Ansonsten Marge verwenden und Verkaufspreis berechnen
        const verkaufspreis = this.artikel.verkaufspreis;
        const einkaufspreis = KieneUtils.isApiOne(this.artikel.stueckliste)
            ? (this.artikel.stueckliste_einkaufspreis || 0)
            : (this.artikel.einzelpreis || 0);
        
        if (verkaufspreis && verkaufspreis > 0 && einkaufspreis && einkaufspreis > 0) {
            // Beide Preise vorhanden - berechne tatsächliche Marge aus den Preisen
            // Verwende die gleiche Formel wie in der Tabelle: Ertrag = ((Verkaufspreis - Einkaufspreis) / Verkaufspreis) * 100
            this.verkaufspreisManuellGesetzt = true;
            this.isCalculatingVerkaufspreis = true;
            // Marge/Ertrag berechnen: ((Verkaufspreis - Einkaufspreis) / Verkaufspreis) * 100
            const berechneteMarge = ((verkaufspreis - einkaufspreis) / verkaufspreis) * 100;
            // Verwende berechnete Marge (ohne Rundung auf 20/30)
            this.margeCtrl.setValue(Math.round(berechneteMarge * 100) / 100, { emitEvent: false });
            this.isCalculatingVerkaufspreis = false;
        } else if (verkaufspreis && verkaufspreis > 0) {
            // Nur Verkaufspreis vorhanden (z.B. bei Leistungsartikeln ohne Einkaufspreis)
            // Setze Verkaufspreis direkt und Marge auf 0
            this.verkaufspreisManuellGesetzt = true;
            this.isCalculatingVerkaufspreis = true;
            this.verkaufspreisCtrl.setValue(verkaufspreis, { emitEvent: false });
            this.margeCtrl.setValue(0, { emitEvent: false });
            this.isCalculatingVerkaufspreis = false;
        } else if (this.artikel.marge) {
            // Marge ist direkt im Artikel gespeichert - verwende diese
            this.verkaufspreisManuellGesetzt = false;
            this.margeCtrl.setValue(this.artikel.marge);
            // Verkaufspreis berechnen
            this.calculateVerkaufspreis();
        } else {
            // Keine Marge vorhanden - Standard 20% verwenden
            this.verkaufspreisManuellGesetzt = false;
            this.margeCtrl.setValue(20);
            // Verkaufspreis berechnen
            this.calculateVerkaufspreis();
        }

        // Einheit setzen, wenn vorhanden (wird auch in loadEinheiten() gesetzt, aber hier als Fallback)
        if (this.artikel.einheit_id !== null && this.artikel.einheit_id !== undefined && this.allEinheiten.length > 0) {
            const einheit = this.allEinheiten.find(e =>
                KieneUtils.sameId(e.einheit_id, this.artikel.einheit_id),
            );
            if (einheit) {
                this.selectedEinheit = einheit;
                // Setze auch im Selector, falls dieser bereits initialisiert ist
                setTimeout(() => {
                    if (this.einheitSelector) {
                        this.einheitSelector.einheitCtrl.setValue(einheit);
                    }
                }, 100);
            }
        } else if (this.artikel.einheit_id !== null && this.artikel.einheit_id !== undefined) {
            // Fallback: Warte auf Einheiten-Laden
            setTimeout(() => {
                if (this.allEinheiten.length > 0) {
                    const einheit = this.allEinheiten.find(e =>
                        KieneUtils.sameId(e.einheit_id, this.artikel.einheit_id),
                    );
                    if (einheit) {
                        this.selectedEinheit = einheit;
                        if (this.einheitSelector) {
                            this.einheitSelector.einheitCtrl.setValue(einheit);
                        }
                    }
                }
            }, 200);
        }

        // Lieferant setzen, wenn vorhanden
        if (this.artikel.lieferant_id_labor) {
            setTimeout(() => {
                if (this.lieferantAutocomplete) {
                    const lieferant = new Supplier();
                    lieferant.lieferant_id = this.artikel.lieferant_id_labor;
                    lieferant.bezeichnung = this.artikel.lieferant_bezeichnung || '';
                    this.selectedLieferant = lieferant;
                }
            }, 100);
        }

        // Prüfe, ob Artikel bereits für mehrere Mandanten existiert
        // Wenn Artikel mit derselben Bezeichnung bei anderen Mandanten existiert, wurde er bereits für mehrere Mandanten erstellt
        this.checkSameNameOtherMandanten();
        setTimeout(() => {
            if (this.artikelSameNameOtherMandanten && this.artikelSameNameOtherMandanten.length > 0) {
                this.wurdeFuerMehrereMandantenErstellt = true;
            }
        }, 500);

        // Bei Stückliste: einzelpreis deaktivieren
        if (KieneUtils.isApiOne(this.artikel.stueckliste)) {
            this.einzelpreisCtrl.disable();
        }

        if (this.artikel.artikel_id) {
            this.updateMaterialForStueckliste(this.artikel.artikel_id, KieneUtils.isApiOne(this.artikel.stueckliste));
        }
    }

    onStuecklisteReload() {
        // Einkaufspreis aus Stückliste neu laden
        // Verzögerung, damit das Backend die Änderungen verarbeitet hat (die Prozedur aktualisiert stueckliste_einkaufspreis)
        setTimeout(() => {
            if (this.artikel.artikel_id) {
                this.loadStuecklisteEinkaufspreis();
            }
        }, 500);
    }

    loadStuecklisteEinkaufspreis() {
        if (this.artikel.artikel_id) {
            // Verwende behandlungsartikel/read_one.php, um den aktuellen stueckliste_einkaufspreis zu laden
            const params = new HttpParams().set('artikel_id', this.artikel.artikel_id.toString());
            this.api.get(this.apiBaseUrl + 'behandlungsartikel/read_one.php', params).subscribe({
                next: (loadedArtikel: any) => {
                    // Einkaufspreis setzen, auch wenn er 0 ist
                    // Der valueChanges-Handler wird automatisch den Verkaufspreis neu berechnen
                    const einkaufspreis = loadedArtikel.stueckliste_einkaufspreis || 0;
                    this.stuecklisteEinkaufspreisCtrl.setValue(einkaufspreis);
                    this.artikel.stueckliste_einkaufspreis = einkaufspreis;
                },
                error: error => {
                },
            });
        }
    }

    onTabChange(index: number) {
        this.selectedTabIndex = index;
        // Wenn zum Stückliste-Tab gewechselt wird und Artikel bereits existiert, Einkaufspreis laden
        if (index === 1 && this.edit && this.artikel.artikel_id && this.stuecklisteCtrl.value) {
            this.loadStuecklisteEinkaufspreis();
        }
    }

    hasPermissionForStueckliste(): boolean {
        return this.localStorageService.currentUserHasPermissions([4401]);
    }

    initCreateMode() {
        // Standardwerte für neuen Artikel
        this.artikeltypCtrl.setValue('labor');
        this.stuecklisteCtrl.setValue(false);
        this.gesperrtCtrl.setValue(false);
        this.margeCtrl.setValue(20); // Standard: 20%
    }

    setEinheit(einheit: Einheit) {
        this.selectedEinheit = einheit || null;
    }

    setLieferant(lieferant: Supplier) {
        this.selectedLieferant = lieferant;
    }

    lieferantDeleted() {
        this.selectedLieferant = null;
        // Einkaufspreis auch auf null setzen, wenn Lieferant entfernt wird
        this.einzelpreisCtrl.setValue(null);
    }

    addNewLieferant() {
        const input = new EnterValueInput();
        input.title = 'Neuen Lieferanten hinzufügen';
        input.text = 'Bitte geben Sie die Daten des neuen Lieferanten ein:';
        input.okButton = 'Erstellen';
        input.addInputValue('Bezeichnung *', 'text');
        input.addInputValue('Email', 'text');
        input.addInputValue('Telefon', 'text');
        input.addInputValue('Strasse', 'text');
        input.addInputValue('PLZ', 'text');
        input.addInputValue('Ort', 'text');

        const dialogRef = this.dialog.open(EnterValueDialogComponent, {
            width: '600px',
            data: input,
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.result === true) {
                const bezeichnung = result.getValue(0);
                if (bezeichnung && bezeichnung.trim() !== '') {
                    // Neuen Lieferanten erstellen
                    // Die interne Nummer wird automatisch vom Backend vergeben
                    const lieferantData: any = {
                        bezeichnung: bezeichnung.trim(),
                        fax_bevorzugen: 0, // Fax nicht bevorzugen
                    };

                    // Optionale Felder hinzufügen, wenn sie ausgefüllt wurden
                    const email = result.getValue(1);
                    if (email && email.trim() !== '') {
                        lieferantData.email = email.trim();
                    }

                    const telefon = result.getValue(2);
                    if (telefon && telefon.trim() !== '') {
                        lieferantData.telefon = telefon.trim();
                    }

                    const strasse = result.getValue(3);
                    if (strasse && strasse.trim() !== '') {
                        lieferantData.strasse = strasse.trim();
                    }

                    const plz = result.getValue(4);
                    if (plz && plz.trim() !== '') {
                        lieferantData.plz = plz.trim();
                    }

                    const ort = result.getValue(5);
                    if (ort && ort.trim() !== '') {
                        lieferantData.ort = ort.trim();
                    }

                    // Verwende update_allgemein.php - wenn keine lieferant_id übergeben wird, wird ein neuer Lieferant erstellt
                    // Die interne Nummer wird automatisch vom Backend vergeben
                    this.api.post(this.apiBaseUrl + 'lieferant/update_allgemein.php', lieferantData).subscribe({
                        next: (response: any) => {
                            if (response.fehler) {
                                this.messageService.errorMessage('Fehler beim Erstellen des Lieferanten', response.fehler);
                            } else {
                                this.messageService.infoMessage('Lieferant erfolgreich erstellt');
                                // Neuen Lieferanten laden und auswählen
                                if (response.lieferant_id) {
                                    this.api.getOne(this.apiBaseUrl + 'lieferant/read_one.php', 'lieferant_id', response.lieferant_id.toString()).subscribe({
                                        next: (lieferant: Supplier) => {
                                            this.selectedLieferant = lieferant;
                                            // Autocomplete aktualisieren - setze kieneObject direkt
                                            if (this.lieferantAutocomplete) {
                                                this.lieferantAutocomplete.kieneObject = lieferant;
                                            }
                                        },
                                        error: error => {
                                            this.messageService.errorMessage('Fehler beim Laden des neuen Lieferanten', error);
                                        },
                                    });
                                }
                            }
                        },
                        error: error => {
                            this.messageService.errorMessage('Fehler beim Erstellen des Lieferanten', error);
                        },
                    });
                } else {
                    this.messageService.errorMessage('Bitte geben Sie eine Bezeichnung ein!', null);
                }
            }
        });
    }

    artikeltypChanged() {
        const typ = this.artikeltypCtrl.value;
        if (typ === 'diagnostik') {
            // Bei Diagnostikartikel: Stückliste deaktivieren (Diagnostikartikel haben keine Stückliste)
            this.stuecklisteCtrl.setValue(false);
            this.stuecklisteCtrl.disable();

            // Bei Diagnostikartikel: Idexx deaktivieren und Felder leeren
            this.idexxCtrl.setValue(false);
            this.idexxCtrl.disable();
            this.idexxMessgroesseCtrl.setValue('');
            this.idexxPdfBeschreibungCtrl.setValue('');
            this.idexxPdfTabellenTextCtrl.setValue('');
            
            // Stücklisten-Einkaufspreis zurücksetzen (wird beim Speichern vom Backend gelöscht)
            this.stuecklisteEinkaufspreisCtrl.setValue(null);
            
            // WICHTIG: Einkaufspreis wieder aktivieren, da Diagnostikartikel keinen Stücklisten-Einkaufspreis haben
            this.einzelpreisCtrl.enable();
            
            // Wenn Artikel bearbeitet wird und Stückliste existiert, Material-Objekt zurücksetzen
            if (this.edit && this.materialForStueckliste) {
                this.materialForStueckliste.stueckliste = 0;
            }
            
            // Verkaufspreis neu berechnen (auch für Diagnostikartikel)
            this.calculateVerkaufspreis();
        } else {
            // Bei Laborartikel: Stückliste aktivieren
            this.stuecklisteCtrl.enable();
            // Bei Laborartikel: Idexx wieder aktivierbar machen
            this.idexxCtrl.enable();
            // Verkaufspreis neu berechnen
            this.calculateVerkaufspreis();
        }
    }

    stuecklisteChanged() {
        const isStueckliste = this.stuecklisteCtrl.value;
        if (isStueckliste) {
            // Bei Stückliste: einzelpreis deaktivieren
            this.einzelpreisCtrl.disable();
            this.einzelpreisCtrl.setValue(null);
            // Wenn Artikel bereits existiert, Einkaufspreis aus Stückliste laden
            if (this.edit && this.artikel.artikel_id) {
                this.loadStuecklisteEinkaufspreis();
            }
            // Verkaufspreis neu berechnen
            this.calculateVerkaufspreis();
        } else {
            this.einzelpreisCtrl.enable();
            // Verkaufspreis neu berechnen
            this.calculateVerkaufspreis();
        }
    }

    calculateVerkaufspreis() {
        // Verkaufspreis berechnen (für Laborartikel und Diagnostikartikel)
        // Marge 0 ist erlaubt (Verkaufspreis = Einkaufspreis), daher nicht auf Truthy prüfen
        if (this.margeCtrl.value !== null && this.margeCtrl.value !== undefined) {
            this.isCalculatingVerkaufspreis = true;
            let einkaufspreis = 0;
            
            // Wenn Stückliste aktiviert ist, verwende Stücklisten-Einkaufspreis (nur für Laborartikel)
            if (this.artikeltypCtrl.value === 'labor' && this.stuecklisteCtrl.value && this.stuecklisteEinkaufspreisCtrl.value && this.stuecklisteEinkaufspreisCtrl.value > 0) {
                einkaufspreis = this.stuecklisteEinkaufspreisCtrl.value;
            } else if (this.einzelpreisCtrl.value && this.einzelpreisCtrl.value > 0) {
                // Normale Berechnung aus Einkaufspreis
                einkaufspreis = this.einzelpreisCtrl.value;
            }
            
            if (einkaufspreis > 0) {
                const marge = this.margeCtrl.value || 0;
                const verkaufspreis = einkaufspreis / (1 - marge / 100);
                // Kaufmännische Rundung auf 2 Nachkommastellen
                const gerundet = Math.round(verkaufspreis * 100) / 100;
                this.verkaufspreisCtrl.setValue(gerundet, { emitEvent: false });
            } else {
                // Kein Einkaufspreis vorhanden
                // Wenn Verkaufspreis manuell gesetzt wurde, behalte ihn
                // Ansonsten setze auf null
                if (!this.verkaufspreisManuellGesetzt) {
                    this.verkaufspreisCtrl.setValue(null, { emitEvent: false });
                }
                // Wenn Verkaufspreis manuell gesetzt wurde, behalte den aktuellen Wert
            }
            this.isCalculatingVerkaufspreis = false;
        }
    }

    calculateMarge() {
        // Marge berechnen (für Laborartikel und Diagnostikartikel)
        // Wird nur aufgerufen, wenn Verkaufspreis manuell geändert wurde
        if (this.verkaufspreisCtrl.value && this.verkaufspreisCtrl.value > 0) {
            this.isCalculatingMarge = true;
            let einkaufspreis = 0;
            
            // Wenn Stückliste aktiviert ist, verwende Stücklisten-Einkaufspreis (nur für Laborartikel)
            if (this.artikeltypCtrl.value === 'labor' && this.stuecklisteCtrl.value && this.stuecklisteEinkaufspreisCtrl.value && this.stuecklisteEinkaufspreisCtrl.value > 0) {
                einkaufspreis = this.stuecklisteEinkaufspreisCtrl.value;
            } else if (this.einzelpreisCtrl.value && this.einzelpreisCtrl.value > 0) {
                // Normale Berechnung aus Einkaufspreis
                einkaufspreis = this.einzelpreisCtrl.value;
            }
            
            if (einkaufspreis > 0) {
                const verkaufspreis = this.verkaufspreisCtrl.value;
                // Marge/Ertrag berechnen: ((Verkaufspreis - Einkaufspreis) / Verkaufspreis) * 100
                // Verwende die gleiche Formel wie in der Tabelle
                const marge = ((verkaufspreis - einkaufspreis) / verkaufspreis) * 100;
                // Verwende berechnete Marge (ohne Rundung auf 20/30, auf 2 Dezimalstellen gerundet)
                this.margeCtrl.setValue(Math.round(marge * 100) / 100, { emitEvent: false });
            } else {
                // Wenn kein Einkaufspreis vorhanden, Standard-Marge beibehalten
                if (!this.margeCtrl.value) {
                    this.margeCtrl.setValue(20, { emitEvent: false });
                }
            }
            this.isCalculatingMarge = false;
        }
    }

    private calculateVerkaufspreisIfNeeded(): number | null {
        let verkaufspreis = this.verkaufspreisCtrl.value;
        if (this.artikeltypCtrl.value === 'labor' && this.stuecklisteCtrl.value) {
            if (this.margeCtrl.value === null || this.margeCtrl.value === undefined) {
                this.margeCtrl.setValue(20, { emitEvent: false });
            }
            if ((!verkaufspreis || verkaufspreis <= 0) && this.stuecklisteEinkaufspreisCtrl.value && this.stuecklisteEinkaufspreisCtrl.value > 0) {
                const einkaufspreis = this.stuecklisteEinkaufspreisCtrl.value;
                const marge = this.margeCtrl.value || 0;
                const vp = marge === 100 ? null : Math.round((einkaufspreis / (1 - marge / 100)) * 100) / 100;
                if (vp && vp > 0) {
                    verkaufspreis = vp;
                    this.verkaufspreisCtrl.setValue(vp, { emitEvent: false });
                }
            }
        }
        return verkaufspreis;
    }

    private buildArtikelData(verkaufspreis?: number): any {
        return {
            bezeichnung: this.bezeichnungCtrl.value,
            bezeichnung_befund: (this.bezeichnungBefundCtrl.value !== null && this.bezeichnungBefundCtrl.value !== undefined)
                ? this.bezeichnungBefundCtrl.value.toString()
                : null,
            kuerzel: (this.kuerzelCtrl.value !== null && this.kuerzelCtrl.value !== undefined)
                ? this.kuerzelCtrl.value.toString().trim()
                : null,
            ean: (this.eanCtrl.value && this.eanCtrl.value.toString().trim() !== '') ? this.eanCtrl.value.toString().trim() : null,
            artikelnr_lieferant: (this.artikelnrLieferantCtrl.value && this.artikelnrLieferantCtrl.value.toString().trim() !== '')
                ? this.artikelnrLieferantCtrl.value.toString().trim()
                : null,
            menge: this.mengeCtrl.value || 1,
            einheit_id: this.selectedEinheit?.einheit_id ?? null,
            einzelpreis: this.stuecklisteCtrl.value ? null : (this.einzelpreisCtrl.value || null),
            verkaufspreis: verkaufspreis || null,
            marge: this.margeCtrl.value || null,
            laborartikel: this.artikeltypCtrl.value === 'labor' ? 1 : 0,
            stueckliste: this.stuecklisteCtrl.value ? 1 : 0,
            lieferant_id_labor: this.selectedLieferant?.lieferant_id || null,
            lieferant_bezeichnung: this.selectedLieferant?.bezeichnung || null,
            gesperrt: this.gesperrtCtrl.value ? 1 : 0,
            idexx: this.idexxCtrl.value ? 1 : 0,
            idexx_messgroesse: this.idexxMessgroesseCtrl.value || null,
            idexx_pdf_beschreibung: this.idexxPdfBeschreibungCtrl.value || null,
            idexx_pdf_tabellen_text: this.idexxPdfTabellenTextCtrl.value || null,
        };
    }

    private updateMaterialForStueckliste(artikelId: number, reloadEinkaufspreis: boolean = false): void {
        this.artikel.artikel_id = artikelId;
        if (!this.materialForStueckliste) {
            this.materialForStueckliste = new Material();
        }
        this.materialForStueckliste.artikel_id = artikelId;
        this.materialForStueckliste.bezeichnung = this.bezeichnungCtrl.value;
        this.materialForStueckliste.stueckliste = this.stuecklisteCtrl.value ? 1 : 0;
        
        if (reloadEinkaufspreis && this.stuecklisteCtrl.value) {
            this.loadStuecklisteEinkaufspreis();
        }
    }

    zwischenspeichern() {
        this.selectedTabIndex = 0;
        if (this.bezeichnungCtrl.invalid) {
            this.messageService.errorMessage('Bitte geben Sie eine Bezeichnung ein!', null);
            return;
        }

        this.isSaving = true;
        const verkaufspreis = this.calculateVerkaufspreisIfNeeded();
        const artikelData = this.buildArtikelData(verkaufspreis);

        if (this.edit) {
            artikelData.artikel_id = this.artikel.artikel_id;
            this.api.post(this.apiBaseUrl + 'behandlungsartikel/update.php', artikelData).subscribe({
                next: response => {
                    this.isSaving = false;
                    if (response.fehler) {
                        this.messageService.errorMessage(response.fehler, null);
                    } else {
                        this.messageService.infoMessage('Artikel erfolgreich gespeichert');
                        if (response.artikel_id) {
                            this.edit = true;
                            this.wurdeFuerMehrereMandantenErstellt = false;
                            this.updateMaterialForStueckliste(response.artikel_id, true);
                        }
                    }
                },
                error: error => {
                    this.isSaving = false;
                    this.messageService.errorMessage('Fehler beim Speichern des Artikels', error);
                },
            });
        } else {
            this.api.post(this.apiBaseUrl + 'behandlungsartikel/create.php', artikelData).subscribe({
                next: response => {
                    this.isSaving = false;
                    if (response.fehler) {
                        this.messageService.errorMessage(response.fehler, null);
                    } else if (response.fehler_recht) {
                        this.messageService.errorMessage(response.fehler_recht, null);
                    } else {
                        this.messageService.infoMessage('Artikel erfolgreich gespeichert');
                        if (response.artikel_id) {
                            this.edit = true;
                            this.wurdeFuerMehrereMandantenErstellt = false;
                            this.updateMaterialForStueckliste(response.artikel_id, true);
                        }
                    }
                },
                error: error => {
                    this.isSaving = false;
                    this.messageService.errorMessage('Fehler beim Erstellen des Artikels', error);
                },
            });
        }
    }

    cancel() {
        this.dialogRef.close();
    }

    private getReadSameNameParams(): HttpParams {
        const lookupBezeichnung = this.artikel?.bezeichnung ?? this.bezeichnungCtrl.value;
        let params = new HttpParams().set('bezeichnung', lookupBezeichnung);
        if (this.artikel?.artikel_id) {
            params = params.set('artikel_id', this.artikel.artikel_id.toString());
        }
        return params;
    }

    private getLinkedArtikelAtOtherMandanten(fromApi: any[]): any[] {
        if (fromApi && fromApi.length > 0) {
            return fromApi;
        }
        return this.artikelSameNameOtherMandanten ?? [];
    }

    private buildAvailableMandantenFromRecords(records: any[]): Mandant[] {
        const einzelpreis = this.stuecklisteCtrl.value
            ? this.stuecklisteEinkaufspreisCtrl.value
            : this.einzelpreisCtrl.value;
        const verkaufspreis = this.verkaufspreisCtrl.value;

        return records.map(r => {
            const mandant = new Mandant();
            mandant.mandant_id = r.mandant_id;
            mandant.bezeichnung = r.bezeichnung;
            (mandant as any).artikel_bezeichnung = this.bezeichnungCtrl.value;
            if (einzelpreis !== null && einzelpreis !== undefined) {
                (mandant as any).einzelpreis = einzelpreis;
            }
            if (verkaufspreis !== null && verkaufspreis !== undefined) {
                (mandant as any).verkaufspreis = verkaufspreis;
            }
            return mandant;
        });
    }

    private buildAvailableMandantenFromLinkedArtikel(artikelSameName: any[]): Mandant[] {
        return artikelSameName.map(a => {
            const mandant = new Mandant();
            mandant.mandant_id = a.mandant_id;
            mandant.bezeichnung = a.mandant_bezeichnung;
            if (a.artikel_bezeichnung !== null && a.artikel_bezeichnung !== undefined) {
                (mandant as any).artikel_bezeichnung = a.artikel_bezeichnung;
            }
            if (a.einzelpreis !== null && a.einzelpreis !== undefined) {
                (mandant as any).einzelpreis = a.einzelpreis;
            }
            if (a.verkaufspreis !== null && a.verkaufspreis !== undefined) {
                (mandant as any).verkaufspreis = a.verkaufspreis;
            }
            return mandant;
        });
    }

    private shouldShowPricesInSaveForAll(availableMandanten: Mandant[]): boolean {
        if (!this.edit) {
            return true;
        }

        const einkaufspreisAlt = this.artikel?.einzelpreis ?? null;
        const stuecklisteEinkaufspreisAlt = this.artikel?.stueckliste_einkaufspreis ?? null;
        const einkaufspreisNeu = this.stuecklisteCtrl.value ? null : (this.einzelpreisCtrl.value ?? null);
        const stuecklisteEinkaufspreisNeu = this.stuecklisteCtrl.value
            ? (this.stuecklisteEinkaufspreisCtrl.value ?? null)
            : null;

        const einkaufspreisGeaendert =
            (einkaufspreisAlt === null && einkaufspreisNeu !== null) ||
            (einkaufspreisAlt !== null && einkaufspreisNeu === null) ||
            (einkaufspreisAlt !== null &&
                einkaufspreisNeu !== null &&
                Math.abs(einkaufspreisAlt - einkaufspreisNeu) > 0.001);

        const stuecklisteEinkaufspreisGeaendert =
            (stuecklisteEinkaufspreisAlt === null && stuecklisteEinkaufspreisNeu !== null) ||
            (stuecklisteEinkaufspreisAlt !== null && stuecklisteEinkaufspreisNeu === null) ||
            (stuecklisteEinkaufspreisAlt !== null &&
                stuecklisteEinkaufspreisNeu !== null &&
                Math.abs(stuecklisteEinkaufspreisAlt - stuecklisteEinkaufspreisNeu) > 0.001);

        let verkaufspreisGeaendert =
            this.verkaufspreisManuellGesetzt ||
            (this.artikel?.verkaufspreis &&
                this.verkaufspreisCtrl.value &&
                Math.abs(this.artikel.verkaufspreis - this.verkaufspreisCtrl.value) > 0.001);

        const margeAlt = this.artikel?.marge ?? null;
        const margeNeu = this.margeCtrl.value ?? null;
        const margeGeaendert =
            (margeAlt === null && margeNeu !== null) ||
            (margeAlt !== null && margeNeu === null) ||
            (margeAlt !== null && margeNeu !== null && Math.abs(margeAlt - margeNeu) > 0.001);

        const hasPrices = availableMandanten.some(m => {
            const mAny = m as any;
            return (
                (mAny.einzelpreis !== null && mAny.einzelpreis !== undefined) ||
                (mAny.verkaufspreis !== null && mAny.verkaufspreis !== undefined)
            );
        });

        const stuecklisteMitEinkaufspreis =
            this.stuecklisteCtrl.value &&
            this.stuecklisteEinkaufspreisCtrl.value !== null &&
            this.stuecklisteEinkaufspreisCtrl.value !== undefined &&
            this.stuecklisteEinkaufspreisCtrl.value > 0;

        return (
            hasPrices ||
            einkaufspreisGeaendert ||
            stuecklisteEinkaufspreisGeaendert ||
            verkaufspreisGeaendert ||
            margeGeaendert ||
            stuecklisteMitEinkaufspreis
        );
    }

    private saveForAllResultToMandantMargeData(result: any): MandantMargeData[] {
        const currentMandantId = Number(this.localStorageService.getCurrentMandant()?.mandant_id);
        const ids = new Set<number>((result?.mandanten_ids ?? []).map((id: number | string) => Number(id)));
        if (currentMandantId) {
            ids.add(currentMandantId);
        }
        return Array.from(ids).map(mandant_id => ({
            mandant_id,
            marge: Number(result?.preise?.[mandant_id]?.marge ?? this.margeCtrl.value ?? 20),
        }));
    }

    private applySaveForAllResultToLinkedArtikel(artikelSameName: any[], result: any): any[] {
        const selectedArtikel = artikelSameName.filter(a =>
            KieneUtils.includesId(result.mandanten_ids, a.mandant_id),
        );

        if (result.bezeichnungen) {
            for (const artikel of selectedArtikel) {
                const bezeichnung = result.bezeichnungen[artikel.mandant_id];
                if (bezeichnung && bezeichnung.trim() !== '') {
                    artikel.bezeichnung = bezeichnung.trim();
                }
            }
        }

        if (result.preise) {
            for (const artikel of selectedArtikel) {
                const preise = result.preise[artikel.mandant_id];
                if (preise) {
                    if (preise.einzelpreis !== null && preise.einzelpreis !== undefined) {
                        artikel.einzelpreis = preise.einzelpreis;
                    }
                    if (preise.verkaufspreis !== null && preise.verkaufspreis !== undefined) {
                        artikel.verkaufspreis = preise.verkaufspreis;
                    }
                }
            }
        }

        return selectedArtikel;
    }

    private openSaveForAllDialog(
        artikelData: any,
        availableMandanten: Mandant[],
        options: { buttonText: string; mode: 'create' | 'editLinked' | 'editExpand'; linkedArtikel?: any[] },
    ): void {
        const dialogRef = this.dialog.open(SaveForAllDialogComponent, {
            width: '700px',
            data: {
                availableMandanten,
                buttonText: options.buttonText,
                showPrices: this.shouldShowPricesInSaveForAll(availableMandanten),
                showBezeichnung: true,
                usePricesFormat: true,
                prefillWithDefaults: true,
                prefillBezeichnung: this.bezeichnungCtrl.value ?? null,
                prefillEinzelpreis: this.stuecklisteCtrl.value
                    ? (this.stuecklisteEinkaufspreisCtrl.value ?? null)
                    : (this.einzelpreisCtrl.value ?? null),
                prefillVerkaufspreis: this.verkaufspreisCtrl.value ?? null,
                prefillMarge: this.margeCtrl.value ?? null,
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result === undefined || result === null) {
                this.isSaving = false;
                return;
            }
            if (!result.mandanten_ids || result.mandanten_ids.length === 0) {
                this.isSaving = false;
                return;
            }

            if (options.mode === 'create') {
                this.createArtikelForMandanten(artikelData, this.saveForAllResultToMandantMargeData(result));
            } else if (options.mode === 'editLinked') {
                const selectedArtikel = this.applySaveForAllResultToLinkedArtikel(
                    options.linkedArtikel ?? [],
                    result,
                );
                this.updateArtikelForAllMandanten(artikelData, selectedArtikel);
            } else {
                this.handleSaveForAllConfirmEditExpand(artikelData, result);
            }
        });
    }

    private loadAvailableMandantenAndOpenSaveForAll(
        artikelData: any,
        mode: 'create' | 'editExpand',
    ): void {
        this.api.get(this.apiBaseUrl + 'artikel/read_mandanten.php').subscribe({
            next: (response: any) => {
                const records = response?.records ?? [];
                if (records.length === 0) {
                    if (mode === 'create') {
                        this.createSingleArtikel(artikelData);
                    } else {
                        this.updateSingleArtikel(artikelData);
                    }
                    return;
                }
                this.openSaveForAllDialog(artikelData, this.buildAvailableMandantenFromRecords(records), {
                    buttonText: mode === 'create' ? 'Speichern' : 'Aktualisieren',
                    mode,
                });
            },
            error: () => {
                this.isSaving = false;
                this.messageService.errorMessage('Mandanten konnten nicht geladen werden.', null);
            },
        });
    }

    private handleSaveForAllConfirmEditExpand(artikelData: any, result: any): void {
        const mandantMargeData = this.saveForAllResultToMandantMargeData(result);
        const currentMandantId = this.localStorageService.getCurrentMandant()?.mandant_id;
        const othersOnly = mandantMargeData.filter(m => m.mandant_id !== currentMandantId);

        artikelData.artikel_id = this.artikel.artikel_id;
        this.api.post(this.apiBaseUrl + 'behandlungsartikel/update.php', artikelData).subscribe({
            next: response => {
                if (response.fehler) {
                    this.isSaving = false;
                    this.messageService.errorMessage(response.fehler, null);
                    return;
                }
                if (othersOnly.length > 0) {
                    this.createArtikelForMandanten(artikelData, mandantMargeData);
                } else {
                    this.isSaving = false;
                    this.messageService.infoMessage('Artikel erfolgreich aktualisiert');
                    if (response.artikel_id) {
                        this.updateMaterialForStueckliste(response.artikel_id, false);
                    }
                    this.dialogRef.close(response);
                }
            },
            error: error => {
                this.isSaving = false;
                this.messageService.errorMessage('Fehler beim Aktualisieren des Artikels', error);
            },
        });
    }

    private openSaveForAllForEdit(artikelData: any, artikelSameName: any[]): void {
        this.openSaveForAllDialog(artikelData, this.buildAvailableMandantenFromLinkedArtikel(artikelSameName), {
            buttonText: 'Aktualisieren',
            mode: 'editLinked',
            linkedArtikel: artikelSameName,
        });
    }

    private handleEditSaveAfterLinkedCheck(artikelData: any, artikelSameNameFromApi: any[]): void {
        const linkedArtikel = this.getLinkedArtikelAtOtherMandanten(artikelSameNameFromApi);

        if (linkedArtikel.length > 0) {
            this.openSaveForAllForEdit(artikelData, linkedArtikel);
        } else if (!this.wurdeFuerMehrereMandantenErstellt) {
            this.loadAvailableMandantenAndOpenSaveForAll(artikelData, 'editExpand');
        } else {
            this.updateSingleArtikel(artikelData);
        }
    }

    save() {
        this.selectedTabIndex = 0;
        if (this.bezeichnungCtrl.invalid) {
            this.messageService.errorMessage('Bitte geben Sie eine Bezeichnung ein!', null);
            return;
        }

        this.isSaving = true;
        const verkaufspreis = this.calculateVerkaufspreisIfNeeded();
        const artikelData = this.buildArtikelData(verkaufspreis);

        // Wenn Artikel bereits existiert, prüfe immer, ob es Artikel bei anderen Mandanten gibt
        if (this.edit) {
            artikelData.artikel_id = this.artikel.artikel_id;
            
            this.api.get(this.apiBaseUrl + 'behandlungsartikel/read_same_name.php', this.getReadSameNameParams()).subscribe({
                next: (response: any) => {
                    let artikelSameName: any[] = [];
                    if (response && response.records) {
                        artikelSameName = response.records;
                    } else if (response && Array.isArray(response)) {
                        artikelSameName = response;
                    }
                    this.handleEditSaveAfterLinkedCheck(artikelData, artikelSameName);
                },
                error: () => {
                    this.handleEditSaveAfterLinkedCheck(artikelData, []);
                },
            });
        } else {
            this.loadAvailableMandantenAndOpenSaveForAll(artikelData, 'create');
        }
    }

    checkSameNameOtherMandanten() {
        if (!this.edit || !this.artikel.bezeichnung) {
            return;
        }

        this.api.get(this.apiBaseUrl + 'behandlungsartikel/read_same_name.php', this.getReadSameNameParams()).subscribe({
            next: (response: any) => {
                if (response && response.records) {
                    this.artikelSameNameOtherMandanten = response.records;
                } else {
                    this.artikelSameNameOtherMandanten = [];
                }
            },
            error: error => {
                this.artikelSameNameOtherMandanten = [];
            },
        });
    }

    private createSingleArtikel(artikelData: any) {
        this.api.post(this.apiBaseUrl + 'behandlungsartikel/create.php', artikelData).subscribe({
            next: response => {
                this.isSaving = false;
                if (response.fehler) {
                    this.messageService.errorMessage(response.fehler, null);
                } else if (response.fehler_recht) {
                    this.messageService.errorMessage(response.fehler_recht, null);
                } else {
                    this.messageService.infoMessage('Artikel erfolgreich erstellt');
                    if (response.artikel_id) {
                        this.edit = true;
                        this.updateMaterialForStueckliste(response.artikel_id, false);
                    }
                    this.dialogRef.close(response);
                }
            },
            error: error => {
                this.isSaving = false;
                this.messageService.errorMessage('Fehler beim Erstellen des Artikels', error);
            },
        });
    }

    updateSingleArtikel(artikelData: any) {
        this.api.post(this.apiBaseUrl + 'behandlungsartikel/update.php', artikelData).subscribe({
            next: response => {
                this.isSaving = false;
                if (response.fehler) {
                    this.messageService.errorMessage(response.fehler, null);
                } else {
                    this.messageService.infoMessage('Artikel erfolgreich aktualisiert');
                    if (response.artikel_id) {
                        this.updateMaterialForStueckliste(response.artikel_id, false);
                    }
                    this.dialogRef.close(response);
                }
            },
            error: error => {
                this.isSaving = false;
                this.messageService.errorMessage('Fehler beim Aktualisieren des Artikels', error);
            },
        });
    }

    updateArtikelForAllMandanten(artikelData: any, artikelSameName?: any[]) {
        // Erstelle Updates für alle Artikel mit derselben Bezeichnung
        const artikelListe = artikelSameName || this.artikelSameNameOtherMandanten || [];
        let updateCount = 0;
        let errorCount = 0;
        const totalCount = artikelListe.length + 1; // +1 für aktuellen Artikel
        
        // WICHTIG: Speichere die ursprüngliche artikel_id vom aktuellen Mandanten,
        // bevor wir die Updates durchführen, damit wir die Stückliste für den richtigen Mandanten laden können
        const originalArtikelId = this.artikel.artikel_id;

        // Zuerst aktuellen Artikel aktualisieren
        this.api.post(this.apiBaseUrl + 'behandlungsartikel/update.php', artikelData).subscribe({
            next: response => {
                updateCount++;
                if (response.fehler) {
                    errorCount++;
                    this.messageService.errorMessage('Fehler beim Aktualisieren des aktuellen Artikels: ' + response.fehler, null);
                }
                this.checkAllUpdatesComplete(updateCount, errorCount, totalCount, response, [], originalArtikelId);
            },
            error: error => {
                updateCount++;
                errorCount++;
                this.messageService.errorMessage('Fehler beim Aktualisieren des aktuellen Artikels', error);
                this.checkAllUpdatesComplete(updateCount, errorCount, totalCount, null, [], originalArtikelId);
            },
        });

        // Sammle erfolgreich aktualisierte Mandanten für Stücklisten-Kopie
        const successfulUpdates: Array<{ artikel_id: number; mandant_id: number; mandant_bezeichnung: string }> = [];
        
        // Dann alle anderen Artikel aktualisieren
        for (const artikelOtherMandant of artikelListe) {
            const artikelDataOtherMandant = { ...artikelData };
            artikelDataOtherMandant.artikel_id = artikelOtherMandant.artikel_id;
            // mandantid wird NICHT übergeben - das Backend setzt es automatisch auf den aktuellen Mandanten
            // Die Prozedur muss den Mandanten aus der artikel_id bestimmen
            
            // Marge entfernen, da sie mandantenspezifisch ist
            delete artikelDataOtherMandant.marge;
            
            // Stückliste mandantenübergreifend aktivieren/deaktivieren
            artikelDataOtherMandant.stueckliste = this.stuecklisteCtrl.value ? 1 : 0;
            
            // Lieferant mandantenübergreifend setzen/entfernen
            artikelDataOtherMandant.lieferant_id_labor = this.selectedLieferant?.lieferant_id || null;
            artikelDataOtherMandant.lieferant_bezeichnung = this.selectedLieferant?.bezeichnung || null;
            
            // Verwende Bezeichnung aus artikelOtherMandant, falls vorhanden (vom Dialog geändert)
            if (artikelOtherMandant.bezeichnung !== null && artikelOtherMandant.bezeichnung !== undefined) {
                artikelDataOtherMandant.bezeichnung = artikelOtherMandant.bezeichnung;
            }
            
            // Verwende Preise aus artikelOtherMandant, falls vorhanden (vom Dialog geändert)
            if (artikelOtherMandant.einzelpreis !== null && artikelOtherMandant.einzelpreis !== undefined) {
                artikelDataOtherMandant.einzelpreis = artikelOtherMandant.einzelpreis;
            }
            if (artikelOtherMandant.verkaufspreis !== null && artikelOtherMandant.verkaufspreis !== undefined) {
                artikelDataOtherMandant.verkaufspreis = artikelOtherMandant.verkaufspreis;
            }

            this.api.post(this.apiBaseUrl + 'behandlungsartikel/update.php', artikelDataOtherMandant).subscribe({
                next: response => {
                    updateCount++;
                    if (response.fehler) {
                        errorCount++;
                        this.messageService.errorMessage(`Fehler beim Aktualisieren für Mandant ${artikelOtherMandant.mandant_bezeichnung}: ${response.fehler}`, null);
                    } else if (this.stuecklisteCtrl.value && response.artikel_id) {
                        // Sammle erfolgreiche Updates für spätere Stücklisten-Kopie
                        const updateEntry = {
                            artikel_id: response.artikel_id,
                            mandant_id: artikelOtherMandant.mandant_id,
                            mandant_bezeichnung: artikelOtherMandant.mandant_bezeichnung
                        };
                        successfulUpdates.push(updateEntry);
                    } else {
                    }
                    this.checkAllUpdatesComplete(updateCount, errorCount, totalCount, response, successfulUpdates, originalArtikelId);
                },
                error: error => {
                    updateCount++;
                    errorCount++;
                    this.messageService.errorMessage(`Fehler beim Aktualisieren für Mandant ${artikelOtherMandant.mandant_bezeichnung}`, error);
                    this.checkAllUpdatesComplete(updateCount, errorCount, totalCount, null, successfulUpdates, originalArtikelId);
                },
            });
        }
    }

    checkAllUpdatesComplete(updateCount: number, errorCount: number, totalCount: number, lastResponse: any, successfulUpdates?: Array<{ artikel_id: number; mandant_id: number; mandant_bezeichnung: string }>, originalArtikelId?: number) {
        if (updateCount === totalCount) {
            this.isSaving = false;
            if (errorCount === 0) {
                this.messageService.infoMessage(`Artikel erfolgreich für ${totalCount} Mandant(en) aktualisiert`);
                if (lastResponse && lastResponse.artikel_id) {
                    this.updateMaterialForStueckliste(lastResponse.artikel_id, false);
                }
                
                
                // WICHTIG: Verwende originalArtikelId (vom aktuellen Mandanten) für das Laden der Stückliste,
                // nicht this.artikel.artikel_id, da das die artikel_id vom letzten Update sein kann (anderer Mandant)
                const artikelIdForStueckliste = originalArtikelId || this.artikel.artikel_id;
                
                // Kopiere Stückliste für alle erfolgreich aktualisierten Mandanten
                if (this.stuecklisteCtrl.value && successfulUpdates && successfulUpdates.length > 0 && artikelIdForStueckliste) {
                    this.copyStuecklisteToAllMandanten(artikelIdForStueckliste, successfulUpdates);
                } else {
                    this.dialogRef.close(lastResponse);
                }
            } else {
                this.messageService.errorMessage('Einige Artikel konnten nicht aktualisiert werden.', null);
                this.dialogRef.close(lastResponse);
            }
        }
    }

    createArtikelForMandanten(artikelData: any, mandantMargeData: MandantMargeData[]) {
        // WICHTIG: Speichere die aktuelle artikel_id VOR allen Änderungen
        // Dies ist die ID des Artikels im aktuellen Mandanten (wurde durch Zwischenspeichern erstellt)
        const originalArtikelId = this.artikel.artikel_id;
        const currentMandantId = Number(this.localStorageService.getCurrentMandant()?.mandant_id);

        const mandantenIds: number[] = [];
        const margen: number[] = [];

        for (const mandantMarge of mandantMargeData) {
            const mandantId = Number(mandantMarge.mandant_id);
            // Nach Zwischenspeichern: aktueller Mandant wurde bereits angelegt
            if (this.edit && this.artikel.artikel_id && mandantId === currentMandantId) {
                continue;
            }
            mandantenIds.push(mandantId);
            margen.push(Number(mandantMarge.marge));
        }

        const otherMandanten = mandantenIds
            .map((mandantId, index) => ({ mandantId, marge: margen[index] }))
            .filter(entry => entry.mandantId !== currentMandantId);
        const needsCreateForCurrent =
            !this.edit && mandantMargeData.some(m => Number(m.mandant_id) === currentMandantId);

        // Neuanlage: create.php mit mandanten_ids erstellt nur Kopien für andere Mandanten.
        // Der aktuelle Mandant braucht immer den Einzel-Create ohne mandanten_ids.
        if (needsCreateForCurrent && otherMandanten.length === 0) {
            this.createSingleArtikel(artikelData);
            return;
        }

        if (needsCreateForCurrent && otherMandanten.length > 0) {
            this.createArtikelForCurrentMandantThenOthers(
                artikelData,
                otherMandanten.map(entry => entry.mandantId),
                otherMandanten.map(entry => entry.marge),
                mandantMargeData,
            );
            return;
        }

        if (mandantenIds.length === 0) {
            if (this.edit && this.artikel.artikel_id) {
                artikelData.artikel_id = this.artikel.artikel_id;
                this.updateSingleArtikel(artikelData);
            } else {
                this.createSingleArtikel(artikelData);
            }
            return;
        }

        // WICHTIG: Lade artikel_nr_intern vom Quell-Artikel, wenn vorhanden
        // Dies stellt sicher, dass alle Mandanten die gleiche artikel_nr_intern haben
        if (originalArtikelId && (!artikelData.artikel_nr_intern || artikelData.artikel_nr_intern <= 0)) {
            const params = new HttpParams().set('artikel_id', originalArtikelId.toString());
            this.api.get(this.apiBaseUrl + 'artikel/read_one.php', params).subscribe({
                next: (artikelResponse: any) => {
                    const artikelNrIntern = artikelResponse?.artikel_nr_intern;
                    if (artikelNrIntern && artikelNrIntern > 0) {
                        artikelData.artikel_nr_intern = artikelNrIntern;
                    }
                    this.createArtikelForMandantenWithData(artikelData, mandantenIds, margen, originalArtikelId, mandantMargeData);
                },
                error: () => {
                    this.createArtikelForMandantenWithData(artikelData, mandantenIds, margen, originalArtikelId, mandantMargeData);
                }
            });
            return;
        }

        // Setze mandanten_ids und margen und rufe create.php auf
        this.createArtikelForMandantenWithData(artikelData, mandantenIds, margen, originalArtikelId, mandantMargeData);
    }

    private createArtikelForCurrentMandantThenOthers(
        artikelData: any,
        otherMandantenIds: number[],
        otherMargen: number[],
        mandantMargeData: MandantMargeData[],
    ): void {
        const payload = { ...artikelData };
        delete payload.mandanten_ids;
        delete payload.margen;

        this.api.post(this.apiBaseUrl + 'behandlungsartikel/create.php', payload).subscribe({
            next: response => {
                if (response.fehler) {
                    this.isSaving = false;
                    this.messageService.errorMessage(response.fehler, null);
                    return;
                }
                if (response.fehler_recht) {
                    this.isSaving = false;
                    this.messageService.errorMessage(response.fehler_recht, null);
                    return;
                }
                if (!response.artikel_id) {
                    this.isSaving = false;
                    this.messageService.errorMessage('Fehler beim Erstellen des Artikels', null);
                    return;
                }

                this.edit = true;
                this.artikel.artikel_id = response.artikel_id;
                if (response.artikel_nr_intern) {
                    artikelData.artikel_nr_intern = response.artikel_nr_intern;
                }

                const otherMandantMargeData = mandantMargeData.filter(m =>
                    KieneUtils.includesId(otherMandantenIds, m.mandant_id),
                );
                this.createArtikelForMandantenWithData(
                    artikelData,
                    otherMandantenIds,
                    otherMargen,
                    response.artikel_id,
                    otherMandantMargeData,
                );
            },
            error: error => {
                this.isSaving = false;
                this.messageService.errorMessage('Fehler beim Erstellen des Artikels', error);
            },
        });
    }

    createArtikelForMandantenWithData(artikelData: any, mandantenIds: number[], margen: number[], originalArtikelId: number, mandantMargeData: MandantMargeData[]) {
        // Füge mandanten_ids und margen zum artikelData hinzu
        artikelData.mandanten_ids = mandantenIds;
        artikelData.margen = margen;

        // Rufe die Prozedur einmal auf, die für alle Mandanten erstellt
        this.api.post(this.apiBaseUrl + 'behandlungsartikel/create.php', artikelData).subscribe({
            next: response => {
                this.isSaving = false;
                if (response.fehler) {
                    this.messageService.errorMessage(response.fehler, null);
                } else if (response.fehler_recht) {
                    this.messageService.errorMessage(response.fehler_recht, null);
                } else {
                    this.messageService.infoMessage(`Artikel erfolgreich für ${mandantenIds.length} Mandant(en) erstellt`);
                    if (response.artikel_id) {
                        this.edit = true;
                        this.wurdeFuerMehrereMandantenErstellt = true;
                        if (this.stuecklisteCtrl.value) {
                            this.updateMaterialForStueckliste(response.artikel_id, false);
                            
                            // WICHTIG: Prüfe, ob Stückliste im aktuellen Mandanten existiert
                            // WICHTIG: Verwende originalArtikelId (aktueller Artikel), nicht response.artikel_id (neuer Artikel im anderen Mandanten)
                            if (!originalArtikelId) {
                                this.messageService.errorMessage('Fehler: Artikel-ID im aktuellen Mandanten nicht gefunden', null);
                                this.dialogRef.close(response);
                                return;
                            }
                            
                            
                            const params = new HttpParams().set('artikel_id_liste', originalArtikelId.toString());
                            this.api.get(this.apiBaseUrl + 'artikel_stueckliste/read.php', params).subscribe({
                                next: (stuecklisteResponse: any) => {
                                    const stuecklistePositions = stuecklisteResponse?.records || [];
                                    
                                    if (stuecklistePositions.length > 0) {
                                        // Stückliste existiert - kopiere sie für andere Mandanten
                                        
                                        // WICHTIG: Da die Artikel gerade erst erstellt wurden, haben wir die artikel_id bereits in der Response
                                        // Die Prozedur behandlungsartikel_create gibt artikel_id_erster_ zurück (die erste erstellte artikel_id)
                                        // Wenn wir nur einen Mandanten haben, ist response.artikel_id die artikel_id für diesen Mandanten
                                        // Erstelle direkt das targetMandanten-Array mit den bekannten Daten
                                        const targetMandanten: Array<{ artikel_id: number; mandant_id: number; mandant_bezeichnung: string }> = [];
                                        
                                        // Wenn wir nur einen Mandanten haben, verwende response.artikel_id direkt
                                        if (mandantenIds.length === 1) {
                                            const targetMandantId = mandantenIds[0];
                                            // Finde Mandanten-Bezeichnung aus mandantMargeData (wurde bereits geladen)
                                            const targetMandantMarge = mandantMargeData.find(m =>
                                                KieneUtils.sameId(m.mandant_id, targetMandantId),
                                            );
                                            // Falls nicht gefunden, lade Mandanten-Liste
                                            if (targetMandantMarge) {
                                                // Verwende Standard-Bezeichnung, da mandantMargeData keine Bezeichnung enthält
                                                const targetMandantBezeichnung = `Mandant ${targetMandantId}`;
                                                
                                                targetMandanten.push({
                                                    artikel_id: response.artikel_id,
                                                    mandant_id: targetMandantId,
                                                    mandant_bezeichnung: targetMandantBezeichnung
                                                });
                                                
                                                this.copyStuecklisteToAllMandanten(originalArtikelId, targetMandanten);
                                            } else {
                                                this.loadArtikelIdsForOtherMandantenAndCopyStueckliste(originalArtikelId, mandantenIds, stuecklistePositions);
                                            }
                                        } else {
                                            // Mehrere Mandanten - verwende loadArtikelIdsForOtherMandantenAndCopyStueckliste
                                            this.loadArtikelIdsForOtherMandantenAndCopyStueckliste(originalArtikelId, mandantenIds, stuecklistePositions);
                                        }
                                    } else {
                                        // Stückliste existiert nicht im aktuellen Mandanten
                                        this.messageService.infoMessage('Stückliste wurde nicht kopiert, da sie im aktuellen Mandanten nicht vorhanden ist.');
                                        this.dialogRef.close(response);
                                    }
                                },
                                error: (error) => {
                                    this.messageService.errorMessage('Fehler beim Laden der Stückliste', error);
                                    this.dialogRef.close(response);
                                }
                            });
                        } else {
                            this.dialogRef.close(response);
                        }
                    } else {
                        this.dialogRef.close(response);
                    }
                }
            },
            error: error => {
                this.isSaving = false;
                this.messageService.errorMessage('Fehler beim Erstellen des Artikels', error);
            },
        });
    }

    copyStuecklisteToAllMandanten(sourceArtikelId: number, targetMandanten: Array<{ artikel_id: number; mandant_id: number; mandant_bezeichnung: string }>) {
        
        // Lade Stücklisten-Positionen vom aktuellen Artikel
        const params = new HttpParams().set('artikel_id_liste', sourceArtikelId.toString());
        this.api.get(this.apiBaseUrl + 'artikel_stueckliste/read.php', params).subscribe({
            next: (response: any) => {
                const stuecklistePositions: ArtikelStueckliste[] = response.records || [];
                // Logge jede Position einzeln
                stuecklistePositions.forEach((pos, index) => {
                });
                
                if (stuecklistePositions.length === 0) {
                    // Keine Stücklisten-Positionen vorhanden, Dialog schließen
                    this.dialogRef.close({ artikel_id: sourceArtikelId });
                    return;
                }
                
                // Kopiere Stückliste für alle Mandanten sequenziell (nacheinander)
                let completedCount = 0;
                const totalCount = targetMandanten.length;
                
                const copyNextMandant = (index: number) => {
                    if (index >= targetMandanten.length) {
                        this.dialogRef.close({ artikel_id: sourceArtikelId });
                        return;
                    }
                    
                    const targetMandant = targetMandanten[index];
                    this.copyStuecklisteToMandant(sourceArtikelId, targetMandant.artikel_id, targetMandant.mandant_id, stuecklistePositions, () => {
                        completedCount++;
                        copyNextMandant(index + 1); // Nächsten Mandanten verarbeiten
                    }, targetMandant.mandant_bezeichnung);
                };
                
                copyNextMandant(0); // Starte mit dem ersten Mandanten
            },
            error: (error) => {
                this.dialogRef.close({ artikel_id: sourceArtikelId });
            },
        });
    }
    
    loadArtikelIdsForOtherMandantenAndCopyStueckliste(sourceArtikelId: number, mandantenIds: number[], stuecklistePositions?: ArtikelStueckliste[]) {
        
        // WICHTIG: Da die Artikel gerade erst erstellt wurden, verwenden wir artikel_nr_intern
        // um die Artikel-IDs in den anderen Mandanten zu finden
        // Lade zuerst die artikel_nr_intern des Quell-Artikels
        const params = new HttpParams().set('artikel_id', sourceArtikelId.toString());
        
        this.api.get(this.apiBaseUrl + 'artikel/read_one.php', params).subscribe({
            next: (artikelResponse: any) => {
                const artikelNrIntern = artikelResponse?.artikel_nr_intern;
                
                if (!artikelNrIntern) {
                    this.messageService.errorMessage('Fehler: Artikel hat keine interne Artikelnummer', null);
                    this.dialogRef.close({ artikel_id: sourceArtikelId });
                    return;
                }
                
                // Finde Artikel-IDs für alle anderen Mandanten über artikel_nr_intern
                const targetMandanten: Array<{ artikel_id: number; mandant_id: number; mandant_bezeichnung: string }> = [];
                let loadedCount = 0;
                const totalToLoad = mandantenIds.length;
                
                if (totalToLoad === 0) {
                    this.dialogRef.close({ artikel_id: sourceArtikelId });
                    return;
                }
                
                const loadNextArtikelId = (index: number) => {
                    if (index >= mandantenIds.length) {
                        
                        // Kopiere Stückliste für alle gefundenen Mandanten
                        if (targetMandanten.length > 0) {
                            this.copyStuecklisteToAllMandanten(sourceArtikelId, targetMandanten);
                        } else {
                            this.dialogRef.close({ artikel_id: sourceArtikelId });
                        }
                        return;
                    }
                    
                    const targetMandantId = mandantenIds[index];
                    
                    // Finde den Artikel im Ziel-Mandanten über artikel_nr_intern
                    const paramsTarget = new HttpParams()
                        .set('artikel_nr_intern', artikelNrIntern.toString())
                        .set('mandant_id', targetMandantId.toString());
                    
                    this.api.get(this.apiBaseUrl + 'artikel/gibArtikel.php', paramsTarget).subscribe({
                        next: (targetArtikelResponse: any) => {
                            const targetArtikelId = targetArtikelResponse.artikel_id;
                            const targetMandantBezeichnung = targetArtikelResponse.mandant_bezeichnung || `Mandant ${targetMandantId}`;
                            
                            if (targetArtikelId) {
                                targetMandanten.push({
                                    artikel_id: targetArtikelId,
                                    mandant_id: targetMandantId,
                                    mandant_bezeichnung: targetMandantBezeichnung
                                });
                            } else {
                            }
                            
                            loadedCount++;
                            loadNextArtikelId(index + 1);
                        },
                        error: (error) => {
                            loadedCount++;
                            loadNextArtikelId(index + 1);
                        }
                    });
                };
                
                loadNextArtikelId(0);
            },
            error: (error) => {
                this.dialogRef.close({ artikel_id: sourceArtikelId });
            },
        });
    }

    copyStuecklisteToMandant(
        sourceArtikelId: number, 
        targetArtikelId: number, 
        targetMandantId: number, 
        stuecklistePositions: ArtikelStueckliste[],
        onComplete?: () => void,
        targetMandantBezeichnung?: string
    ) {
        
        // Speichere targetMandantBezeichnung für Verwendung im Closure
        const mandantBezeichnung = targetMandantBezeichnung || 'Ziel-Mandant';
        
        // WICHTIG: Vollständige Synchronisierung
        // 1. Lade vorhandene Positionen im Ziel-Mandanten
        // 2. Kopiere fehlende Positionen
        // 3. Lösche überflüssige Positionen
        
        // Lade vorhandene Positionen im Ziel-Mandanten
        // WICHTIG: Wir müssen die Positionen über die artikel_nr_intern finden, da die API read.php
        // nur Positionen für den aktuellen Mandanten zurückgibt
        // Verwende die neue API read_for_mandant.php, die Positionen für einen bestimmten Mandanten lädt
        // Diese API findet den Ziel-Artikel über artikel_nr_intern und lädt dann die Positionen
        const params = new HttpParams()
            .set('artikel_id_liste', sourceArtikelId.toString())
            .set('target_mandant_id', targetMandantId.toString());
        this.api.get(this.apiBaseUrl + 'artikel_stueckliste/read_for_mandant.php', params).subscribe({
            next: (targetResponse: any) => {
                const targetPositions: ArtikelStueckliste[] = targetResponse.records || [];
                targetPositions.forEach((pos, idx) => {
                });
                
                // Erstelle eine Map der Quell-Positionen (key: artikel_nr_intern)
                // WICHTIG: Verwende artikel_nr_intern statt artikel_id_pos, da artikel_id_pos in verschiedenen Mandanten unterschiedlich sein kann
                const sourcePositionsMap = new Map<number, ArtikelStueckliste>();
                if (stuecklistePositions) {
                    stuecklistePositions.forEach((pos, idx) => {
                        if (pos.artikel_nr_intern && pos.artikel_nr_intern > 0) {
                            sourcePositionsMap.set(pos.artikel_nr_intern, pos);
                        } else {
                        }
                    });
                } else {
                }
                
                // Erstelle eine Map der Ziel-Positionen (key: artikel_nr_intern)
                // WICHTIG: artikel_nr_intern kann NULL sein, wenn der Artikel keine hat
                const targetPositionsMap = new Map<number, ArtikelStueckliste>();
                targetPositions.forEach(pos => {
                    // artikel_nr_intern kann NULL sein - das ist OK, wir verwenden es trotzdem für den Vergleich
                    // NULL wird als 0 behandelt, was nicht in der Map gespeichert werden sollte
                    if (pos.artikel_nr_intern && pos.artikel_nr_intern > 0) {
                        targetPositionsMap.set(pos.artikel_nr_intern, pos);
                    } else {
                        // WICHTIG: Positionen ohne artikel_nr_intern können nicht verglichen werden
                        // Sie werden trotzdem in positionsToDelete geprüft, um zu sehen, ob sie gelöscht werden müssen
                    }
                });
                
                // Finde Positionen, die gelöscht werden müssen (im Ziel vorhanden, aber nicht im Quell)
                // WICHTIG: Positionen ohne artikel_nr_intern werden auch gelöscht, wenn sie nicht in der Quelle sind
                const positionsToDelete: ArtikelStueckliste[] = [];
                targetPositions.forEach(targetPos => {
                    // Prüfe, ob artikel_nr_intern vorhanden und gültig ist (> 0)
                    if (!targetPos.artikel_nr_intern || targetPos.artikel_nr_intern === 0) {
                        // Position hat keine gültige artikel_nr_intern
                        // Prüfe, ob diese Position in der Quelle vorhanden ist
                        // Da wir keine artikel_nr_intern haben, können wir nicht direkt vergleichen
                        // ABER: Wenn alle Positionen in der Quelle eine gültige artikel_nr_intern haben,
                        // dann bedeutet das, dass diese Position nicht in der Quelle ist
                        // LÖSUNG: Positionen ohne artikel_nr_intern werden gelöscht, wenn sie nicht in der Quelle sind
                        // Wir prüfen, ob es eine Position in der Quelle gibt, die denselben Artikel hat
                        // Dazu müssen wir die artikel_nr_intern des Artikels vom Quell-Mandanten finden
                        // und dann prüfen, ob es eine Position in der Quelle gibt, die diesen Artikel hat
                        
                        // Prüfe, ob es eine Position in der Quelle gibt, die denselben Artikel hat
                        // Da wir keine artikel_nr_intern haben, können wir nicht direkt vergleichen
                        // ABER: Wenn die Quelle eine artikel_nr_intern hat, dann bedeutet das, dass diese Position nicht in der Quelle ist
                        // LÖSUNG: Positionen ohne artikel_nr_intern werden gelöscht, wenn sie nicht in der Quelle sind
                        // (basierend auf der Annahme, dass alle Positionen in der Quelle eine gültige artikel_nr_intern haben)
                        
                        // Prüfe, ob es eine Position in der Quelle gibt, die denselben Artikel hat
                        // Da wir keine artikel_nr_intern haben, können wir nicht direkt vergleichen
                        // ABER: Wenn alle Positionen in der Quelle eine gültige artikel_nr_intern haben,
                        // dann bedeutet das, dass diese Position nicht in der Quelle ist
                        // LÖSUNG: Positionen ohne artikel_nr_intern werden gelöscht
                        positionsToDelete.push(targetPos);
                    } else if (!sourcePositionsMap.has(targetPos.artikel_nr_intern)) {
                        // Position ist im Ziel vorhanden, aber nicht im Quell -> muss gelöscht werden
                        positionsToDelete.push(targetPos);
                    } else {
                        // Position ist in beiden vorhanden -> wird nicht gelöscht
                    }
                });
                
                // Finde Positionen, die kopiert/aktualisiert werden müssen
                // WICHTIG: Positionen, die bereits existieren, aber eine andere Menge haben, müssen auch aktualisiert werden
                const positionsToCopy: ArtikelStueckliste[] = [];
                if (stuecklistePositions) {
                    stuecklistePositions.forEach(sourcePos => {
                        // Prüfe, ob artikel_nr_intern vorhanden und gültig ist
                        if (!sourcePos.artikel_nr_intern || sourcePos.artikel_nr_intern === 0) {
                            // Position wird nicht kopiert, da wir sie nicht vergleichen können
                        } else if (!targetPositionsMap.has(sourcePos.artikel_nr_intern)) {
                            // Position ist im Quell vorhanden, aber nicht im Ziel -> muss kopiert werden
                            positionsToCopy.push(sourcePos);
                        } else {
                            // Position ist bereits im Ziel vorhanden -> prüfe, ob sich die Menge geändert hat
                            const targetPos = targetPositionsMap.get(sourcePos.artikel_nr_intern);
                            if (targetPos) {
                                // Vergleiche die Menge
                                const sourceMenge = sourcePos.artikelmenge || 0;
                                const targetMenge = targetPos.artikelmenge || 0;
                                
                                if (sourceMenge !== targetMenge) {
                                    // Menge hat sich geändert -> muss aktualisiert werden
                                    positionsToCopy.push(sourcePos);
                                } else {
                                    // Position ist identisch -> wird nicht kopiert/aktualisiert
                                }
                            } else {
                                // Sollte nicht passieren, da targetPositionsMap.has() true war
                            }
                        }
                    });
                }
                
                positionsToDelete.forEach((pos, idx) => {
                });
                positionsToCopy.forEach((pos, idx) => {
                });
                
                // VALIDIERUNG: Prüfe, ob die Logik korrekt ist
                const expectedFinalCount = stuecklistePositions?.length || 0;
                const currentTargetCount = targetPositions.length;
                const toDeleteCount = positionsToDelete.length;
                const toCopyCount = positionsToCopy.length;
                const expectedFinalTargetCount = currentTargetCount - toDeleteCount + toCopyCount;
                if (expectedFinalCount !== expectedFinalTargetCount) {
                }
                
                // Lösche überflüssige Positionen zuerst
                let deleteCompleted = 0;
                const deleteNext = (index: number) => {
                    if (index >= positionsToDelete.length) {
                        // Alle Löschungen abgeschlossen - kopiere jetzt fehlende Positionen
                        // Verwende positionsToCopy, die bereits gefiltert wurden (ist im Scope verfügbar)
                        // WICHTIG: Nur kopieren, wenn es tatsächlich Positionen zum Kopieren gibt
                        // positionsToCopy enthält nur die Positionen, die im Ziel fehlen
                        if (positionsToCopy.length > 0) {
                            this.copyPositionsToMandant(sourceArtikelId, targetMandantId, positionsToCopy, mandantBezeichnung, onComplete);
                        } else {
                            if (onComplete) onComplete();
                        }
                        return;
                    }
                    
                    const posToDelete = positionsToDelete[index];
                    
                    // WICHTIG: Die Prozedur artikel_stueckliste_delete erwartet die as_id vom aktuellen Mandanten
                    // Die Position, die gelöscht werden soll, existiert aber nur im Ziel-Mandanten
                    // Daher müssen wir prüfen, ob die Position im aktuellen Mandanten existiert
                    // Wenn nicht, müssen wir sie direkt im Ziel-Mandanten löschen
                    
                    let sourceAsId: number | null = null;
                    
                    // Prüfe, ob die Position im aktuellen Mandanten existiert (in der Quelle)
                    if (posToDelete.artikel_nr_intern && posToDelete.artikel_nr_intern > 0) {
                        // Suche in den Quell-Positionen nach einer Position mit derselben artikel_nr_intern
                        const sourcePos = stuecklistePositions?.find(sp => 
                            sp.artikel_nr_intern && sp.artikel_nr_intern === posToDelete.artikel_nr_intern
                        );
                        
                        if (sourcePos && sourcePos.as_id) {
                            // Position existiert im aktuellen Mandanten - verwende diese as_id
                            sourceAsId = sourcePos.as_id;
                        } else {
                            // Position existiert NICHT im aktuellen Mandanten - nur im Ziel-Mandanten
                            // Die Prozedur kann diese Position nicht löschen, da sie die as_id vom aktuellen Mandanten benötigt
                            // LÖSUNG: Wir müssen die Position direkt im Ziel-Mandanten löschen
                            // Dazu verwenden wir die as_id vom Ziel-Mandanten, aber die Prozedur wird sie nicht finden
                            // ABER: Die Prozedur prüft zuerst, ob die Position im aktuellen Mandanten existiert
                            // Wenn nicht, wird sie einen Fehler werfen
                            // BESSER: Wir müssen die Prozedur so aufrufen, dass sie die Position direkt im Ziel-Mandanten löscht
                            // Dazu müssen wir eine Dummy-as_id verwenden oder die Prozedur anpassen
                            // FÜR JETZT: Verwende die as_id vom Ziel-Mandanten und hoffe, dass die Prozedur sie findet
                            // ABER: Die Prozedur wird die Position im aktuellen Mandanten nicht finden
                            // Verwende die as_id vom Ziel-Mandanten - die Prozedur wird die Position im aktuellen Mandanten nicht finden
                            // aber sie sollte die Position im Ziel-Mandanten trotzdem löschen können
                            sourceAsId = posToDelete.as_id;
                        }
                    } else {
                        // Position hat keine artikel_nr_intern - kann nicht verglichen werden
                        // Verwende die as_id vom Ziel-Mandanten
                        sourceAsId = posToDelete.as_id;
                    }
                    
                    const deleteData: any = {
                        as_id: sourceAsId,
                        mandanten_ids: [targetMandantId]
                    };
                    
                    this.api.deleteEntity(this.apiBaseUrl + 'artikel_stueckliste/delete.php', deleteData).subscribe({
                        next: (response) => {
                            deleteCompleted++;
                            deleteNext(index + 1);
                        },
                        error: (error) => {
                            deleteCompleted++;
                            const errorText = error?.error?.errortext || error?.message || 'Unbekannter Fehler';
                            deleteNext(index + 1); // Weiter mit nächster Position
                        }
                    });
                };
                
                if (positionsToDelete.length > 0) {
                    deleteNext(0);
                } else {
                    // Keine Positionen zum Löschen - kopiere nur fehlende Positionen
                    // WICHTIG: Nur kopieren, wenn es tatsächlich Positionen zum Kopieren gibt
                    if (positionsToCopy.length > 0) {
                        this.copyPositionsToMandant(sourceArtikelId, targetMandantId, positionsToCopy, mandantBezeichnung, onComplete);
                    } else {
                        if (onComplete) onComplete();
                    }
                }
            },
            error: (error) => {
                // Fallback: Kopiere einfach alle Positionen (ohne Synchronisierung)
                this.copyPositionsToMandant(sourceArtikelId, targetMandantId, stuecklistePositions, mandantBezeichnung, onComplete);
            }
        });
    }
    
    /**
     * Kopiert Positionen zu einem Mandanten (ohne Synchronisierung)
     */
    copyPositionsToMandant(
        sourceArtikelId: number,
        targetMandantId: number,
        stuecklistePositions: ArtikelStueckliste[],
        mandantBezeichnung: string,
        onComplete?: () => void
    ) {
        
        if (!stuecklistePositions || stuecklistePositions.length === 0) {
            if (onComplete) onComplete();
            return;
        }
        
        let copiedCount = 0;
        const totalPositions = stuecklistePositions.length;
        const currentMandant = this.localStorageService.getCurrentMandant();
        const currentMandantId = currentMandant?.mandant_id;
        
        
        // WICHTIG: Kopiere Positionen sequenziell (nacheinander), um Deadlocks zu vermeiden
        // Die Prozedur artikel_stueckliste_update verwendet gibArtikel(), um automatisch
        // die richtige artikel_id für den anderen Mandanten über artikel_nr_intern zu finden
        // WICHTIG: mandantid muss der aktuelle Mandant sein (von dem aus kopiert wird),
        // mandanten_ids enthält die Ziel-Mandanten
        // WICHTIG: as_id muss null sein, damit die Prozedur die Position für den aktuellen Mandanten erstellt/aktualisiert
        // und dann für den anderen Mandanten kopiert
        
        const copyNextPosition = (index: number) => {
            if (index >= stuecklistePositions.length) {
                // Alle Positionen verarbeitet
                if (onComplete) {
                    onComplete();
                }
                return;
            }
            
            const position = stuecklistePositions[index];
            
            // Extrahiere Bezeichnung ohne Menge/Einheit in Klammern (z.B. "Aciphen 1000 mg / g (1 kg)" -> "Aciphen 1000 mg / g")
            let artikelBezeichnung: string | null = null;
            if (position.artikel_pos) {
                const match = position.artikel_pos.match(/^(.+?)\s*\(/);
                artikelBezeichnung = match ? match[1].trim() : position.artikel_pos.trim();
            }
            
            // Erstelle Stücklisten-Position für anderen Mandanten
            // Die Prozedur findet automatisch die richtige artikel_id_pos für den anderen Mandanten
            // WICHTIG: benutzerid und mandantid dürfen NICHT gesendet werden - die API setzt sie automatisch
            // basierend auf dem eingeloggten Benutzer und seinem aktuellen Mandanten
            const stuecklisteData: any = {
                as_id: null, // Wichtig: null setzen, damit die Prozedur die Position für den aktuellen Mandanten erstellt/aktualisiert
                artikel_id_liste: sourceArtikelId, // Vom aktuellen Mandanten - Prozedur findet automatisch die richtige ID für anderen Mandanten
                artikel_id_pos: position.artikel_id_pos, // Vom aktuellen Mandanten - Prozedur findet automatisch die richtige ID für anderen Mandanten
                artikel_nr_intern_pos: position.artikel_nr_intern || null, // WICHTIG: Sende artikel_nr_intern aus Position mit, falls Artikel keine hat
                artikel_pos_bezeichnung: artikelBezeichnung, // WICHTIG: Sende Bezeichnung ohne Klammern als Fallback, wenn artikel_nr_intern nicht funktioniert
                artikelmenge: position.artikelmenge || 0,
                indikation_id: position.indikation_id || null,
                tierart_id: position.tierart_id || null,
                anwendungsdauer: position.anwendungsdauer || 0,
                dosierung: position.dosierung || 0,
                anwendung_id: position.anwendung_id || null,
                wartezeit: position.wartezeit || 0,
                behandlung: position.behandlung || 0,
                mandanten_ids: [targetMandantId], // Ziel-Mandant
            };
            
            
            this.api.post(this.apiBaseUrl + 'artikel_stueckliste/update.php', stuecklisteData).subscribe({
                next: (response) => {
                    copiedCount++;
                    // Position erfolgreich kopiert - kopiere nächste Position
                    copyNextPosition(index + 1);
                },
                error: (error) => {
                    copiedCount++;
                    const errorText = error?.error?.errortext || error?.message || 'Unbekannter Fehler';
                    
                    // Prüfe, ob Artikel nicht existiert
                    // Die Prozedur gibt "Keine interne Artikel Nr. vergeben" zurück, wenn gibArtikel() NULL zurückgibt
                    // Das bedeutet, dass der Artikel im Ziel-Mandanten nicht existiert
                    const artikelExistiertNicht = errorText.includes('Keine interne Artikel Nr. vergeben') || 
                                                   errorText.includes('Keine interne Artikel Nr. vergeben!') ||
                                                   errorText.includes('artikel existiert nicht') ||
                                                   errorText.toLowerCase().includes('artikel nicht gefunden');
                    
                    if (artikelExistiertNicht) {
                        // Frage, ob Artikel für den Mandanten angelegt werden soll
                        const confirmInput = new ConfirmDialogInput();
                        confirmInput.headline = 'Artikel nicht gefunden';
                        confirmInput.text = `Der Artikel "${position.artikel_pos}" existiert nicht im Mandanten "${mandantBezeichnung}".\n\nSoll der Artikel für diesen Mandanten angelegt werden?`;
                        confirmInput.okButton = 'Ja, anlegen';
                        confirmInput.cancelButton = 'Nein, überspringen';
                        confirmInput.showCancel = true;
                        confirmInput.isWarning = false;
                        
                        const confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
                            width: '500px',
                            data: confirmInput,
                        });
                        
                        confirmDialogRef.afterClosed().subscribe((confirmResult: any) => {
                            if (confirmResult?.ok) {
                                // Artikel für den Ziel-Mandanten anlegen
                                this.createArtikelForMandantFromPosition(position, targetMandantId, mandantBezeichnung, (newArtikelId?: number) => {
                                    // Artikel wurde angelegt - versuche Position erneut zu kopieren
                                    
                                    // WICHTIG: Wenn newArtikelId vorhanden ist, aktualisiere die Position mit der neuen artikel_id_pos
                                    if (newArtikelId) {
                                        // Aktualisiere die Position mit der neuen artikel_id_pos für den Ziel-Mandanten
                                        // Dies ermöglicht es, die Position direkt mit der neuen artikel_id zu kopieren
                                        const updatedPosition = { ...position };
                                        // Speichere die neue artikel_id für den Ziel-Mandanten (wird später verwendet)
                                        (updatedPosition as any).targetArtikelId = newArtikelId;
                                        stuecklistePositions[index] = updatedPosition;
                                    }
                                    
                                    copyNextPosition(index); // Erneut versuchen (gleicher Index)
                                });
                            } else {
                                // Überspringe Position
                                this.messageService.infoMessage(
                                    `Position "${position.artikel_pos}" wurde übersprungen.`
                                );
                                // Nächste Position kopieren
                                copyNextPosition(index + 1);
                            }
                        });
                    } else if (errorText.includes('Deadlock')) {
                        // Deadlock - versuche erneut nach kurzer Verzögerung
                        setTimeout(() => {
                            copyNextPosition(index); // Erneut versuchen (gleicher Index)
                        }, 1000);
                    } else {
                        // Anderer Fehler - zeige Meldung und überspringe
                        this.messageService.infoMessage(
                            `Position "${position.artikel_pos}" konnte nicht kopiert werden: ${errorText}`
                        );
                        // Nächste Position kopieren
                        copyNextPosition(index + 1);
                    }
                },
            });
        };
        
        // Starte sequenzielles Kopieren mit der ersten Position
        copyNextPosition(0);
    }

    /**
     * Erstellt einen Artikel für einen Mandanten basierend auf einer Stücklisten-Position
     * Lädt die Artikel-Daten vom aktuellen Mandanten und erstellt sie für den Ziel-Mandanten
     */
    createArtikelForMandantFromPosition(
        position: ArtikelStueckliste,
        targetMandantId: number,
        targetMandantBezeichnung: string,
        onComplete?: (newArtikelId?: number) => void
    ) {
        
        // WICHTIG: Prüfe zuerst, ob die Position eine artikel_nr_intern hat
        // Wenn ja, verwende diese direkt, anstatt den Artikel zu laden
        // Dies ist schneller und vermeidet Probleme, wenn der Artikel keine artikel_nr_intern hat
        let artikelNrInternToUse: number | null = null;
        if (position.artikel_nr_intern && position.artikel_nr_intern > 0) {
            artikelNrInternToUse = position.artikel_nr_intern;
        }
        
        // Lade Artikel-Daten vom aktuellen Mandanten
        const params = new HttpParams().set('artikel_id', position.artikel_id_pos.toString());
        this.api.get(this.apiBaseUrl + 'behandlungsartikel/read_one.php', params).subscribe({
            next: (response: any) => {
                const artikelData = response as BehandlungsartikelData;
                
                // WICHTIG: Verwende artikel_nr_intern aus Position, wenn verfügbar, sonst vom Artikel
                // Die Position hat immer die korrekte artikel_nr_intern, auch wenn der Artikel keine hat
                const finalArtikelNrIntern = artikelNrInternToUse || artikelData.artikel_nr_intern || null;
                
                // Erstelle Artikel-Daten für den Ziel-Mandanten
                // WICHTIG: artikel_nr_intern muss vom ursprünglichen Artikel übernommen werden,
                // damit die Prozedur artikel_stueckliste_update den Artikel im Ziel-Mandanten finden kann
                const artikelDataForMandant: any = {
                    bezeichnung: artikelData.bezeichnung || '',
                    bezeichnung_befund: artikelData.bezeichnung_befund || '',
                    kuerzel: artikelData.kuerzel || '',
                    ean: artikelData.ean || '',
                    menge: artikelData.menge || 1,
                    einheit_id: artikelData.einheit_id ?? 0,
                    laborartikel: artikelData.laborartikel || 0,
                    befund: artikelData.befund || 0,
                    stueckliste: 0, // Stückliste wird nicht kopiert (nur der Artikel selbst)
                    gesperrt: artikelData.gesperrt || 0,
                    idexx: artikelData.idexx || 0,
                    idexx_messgroesse: artikelData.idexx_messgroesse || '',
                    idexx_pdf_beschreibung: artikelData.idexx_pdf_beschreibung || '',
                    idexx_pdf_tabellen_text: artikelData.idexx_pdf_tabellen_text || '',
                    lieferant_id_labor: artikelData.lieferant_id_labor || null,
                    einzelpreis: artikelData.einzelpreis || null,
                    verkaufspreis: artikelData.verkaufspreis || null,
                    artikel_nr_intern: finalArtikelNrIntern, // WICHTIG: Verwende artikel_nr_intern aus Position oder Artikel
                    mandanten_ids: [targetMandantId],
                    margen: [this.margeCtrl.value || 20], // Verwende Standard-Marge oder aktuelle Marge
                };
                
                
                // Erstelle Artikel für den Ziel-Mandanten
                this.api.post(this.apiBaseUrl + 'behandlungsartikel/create.php', artikelDataForMandant).subscribe({
                    next: (response: any) => {
                        if (response.fehler) {
                            this.messageService.errorMessage(
                                `Fehler beim Anlegen des Artikels "${position.artikel_pos}" für Mandant "${targetMandantBezeichnung}": ${response.fehler}`,
                                null
                            );
                            if (onComplete) onComplete();
                        } else {
                            this.messageService.infoMessage(
                                `Artikel "${position.artikel_pos}" wurde erfolgreich für Mandant "${targetMandantBezeichnung}" angelegt.`
                            );
                            // WICHTIG: Übergebe die neue artikel_id an onComplete, damit sie beim erneuten Kopieren verwendet werden kann
                            const newArtikelId = response.artikel_id;
                            
                            // WICHTIG: Erhöhte Verzögerung, um sicherzustellen, dass die Datenbank-Transaktion committed ist
                            // und die artikel_nr_intern verfügbar ist für gibArtikel()
                            // Die Prozedur behandlungsartikel_create committed die Transaktion,
                            // aber es kann sein, dass die artikel_nr_intern noch nicht in allen
                            // Datenbank-Views verfügbar ist, besonders wenn der Artikel gerade erst erstellt wurde
                            // Erhöhe die Verzögerung auf 1000ms, um sicherzustellen, dass alles committed ist
                            setTimeout(() => {
                                if (onComplete) onComplete(newArtikelId);
                            }, 1000);
                        }
                    },
                    error: (error) => {
                        const errorText = error?.error?.errortext || error?.message || 'Unbekannter Fehler';
                        this.messageService.errorMessage(
                            `Fehler beim Anlegen des Artikels "${position.artikel_pos}" für Mandant "${targetMandantBezeichnung}": ${errorText}`,
                            error
                        );
                        if (onComplete) onComplete();
                    },
                });
            },
            error: (error) => {
                this.messageService.errorMessage(
                    `Fehler beim Laden der Artikel-Daten für "${position.artikel_pos}"`,
                    error
                );
                if (onComplete) onComplete();
            },
        });
    }
}

